import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation OnlineOrderStartCooking($id: ID!, $input: OnlineOrderOwnerStartCookingInput!) {
    onlineOrderOwnerStartCooking(id: $id, input: $input)
  }
`);

export default function useStartCookingOnlineOrder() {
  return useMutation(MUTATION, {
    refetchQueries: ['OnlineOrderDetail', 'OnlineOrderDashboard', 'OnlineOrderHistory'],
  });
}
